const footerInfo = {
  title: 'CONTACT US',
  email: 'PHQ@LincolnInstituteTraining.com',
  titleSub: 'Program Headquarters',
  telephone: '855-318-2292',
  lastLine: '®2019 Lincoln Motor Company. All right reserved',
};

export default footerInfo;
